import { createEmptySliceBase, injectTabSlice, toReducer } from '../sliceFactory';

const createPaymentsReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'payments' });
  const withTabs = injectTabSlice({ initialTab: 0, sliceBase });
  return toReducer(withTabs);
};

export default createPaymentsReducer;
